var timelinePlugin = function (element, options) {

    var $element = $(element)
    var settings = $.extend({
        tableIdentifier: '#users-table',
        itemIdentifier: '.timeline',
        wrapperClass: 'timelineWrapper',
        headerClass: 'timelineHeader',
        parentHeaderClass: 'parentHeaderRow',
        bodyClass: 'timelineBody',
        itemClass: 'timelineItem',
        datastore: 'timelineDatastore',
        headerRenderPosition: 4,
        headerColumnLength: 4,
        parts: 4,
        range: 9,
        start: new Date().getFullYear() - 2,
        standalone: false,
        standaloneClass: '.timeline_standalone',
        debug: false,
        toggleCheckbox: '.toggle-timeline'
    }, options || {})

    var create = function (tag, attributesOrText, text) {
        // All properties set?
        if (typeof tag !== 'string') {
            throw 'tag name is required.'
        }
        if (typeof attributesOrText === 'object') {
            var attributes = attributesOrText
        } else if (typeof attributesOrText === 'string') {
            var text = attributesOrText
        }
        if (typeof text === 'undefined') {
            var text = null
        }
        // build dom element
        var domElement = document.createElement(tag)
        if (attributes) {
            for (var key in attributes) {
                domElement.setAttribute(key, attributes[key])
            }
        }
        if (text) {
            var textNode = document.createTextNode(text)
            domElement.appendChild(textNode)
        }
        return domElement
    }

    var createHeader = function () {
        var range = settings.range
        var year = settings.start
        var headerTable = create('table', {class: settings.headerClass})
        var headerTableWrapper = create('div', {class: settings.wrapperClass})
        var headerTableHead = create('thead')
        var headerTableYears = create('tr')
        var headerTableQuarters = create('tr')
        for (i = 0; i < range; i++) {
            headerTableYears.appendChild(create('th', {colspan: settings.parts, class: 'year year_' + year}, year))
            for (var q = 0; q < settings.parts; q++) {
                headerTableQuarters.appendChild(create('th', {class: 'quarter  quarter_' + String(q + 1) + ' year_' + year}, String(q + 1)))
            }
            year++
        }
        headerTable.appendChild(headerTableHead)
        headerTable.appendChild(headerTableYears)
        headerTable.appendChild(headerTableQuarters)

        headerTableWrapper.appendChild(headerTable)
        var headerArrowPrev = create('img', {src: '/dist/images/arrow-with-background.svg', class: 'prevArrow'})
        var headerArrowNext = create('img', {src: '/dist/images/arrow-with-background.svg', class: 'nextArrow'})
        var parentTableRowExtension = create('tr', {class: settings.parentHeaderClass})
        for (i = 0; i < settings.headerColumnLength; i++) {
            var parentTableRowColumn = create('th')
            if ((i + 1) === settings.headerRenderPosition) {
                parentTableRowColumn.appendChild(headerArrowPrev)
                parentTableRowColumn.appendChild(headerArrowNext)
                parentTableRowColumn.appendChild(headerTableWrapper)
            }
            parentTableRowExtension.appendChild(parentTableRowColumn)
        }
        return parentTableRowExtension
    }

    var createBody = function ($bodyElement) {
        var storage = []
        var entries = $bodyElement.data().entries
        if (typeof entries == 'string') {
            entries = JSON.parse(entries)
        }
        for (var e = 0; e < entries.length; e++) {
            var entry = entries[e]
            if (entry.year < settings.start) {
                entry.year = settings.start
                entry.quarter = 1
            }
            storage[entry.year + '' + entry.quarter] = {
                compare: entry.year + '' + entry.quarter,
                next: entries[e + 1],
                class: 'status_' + entry.id
            }
            var css = create('style', '#roadmap-wrapper .timelineItem.status_' + entry.id + ':before {border-color: ' + entry.color + ';}' +
                '#roadmap-wrapper .timelineItem.status_' + entry.id + ' .circle {background-color: ' + entry.color + ';}')
            $('head').append(css)
        }

        var range = settings.range
        var year = settings.start
        var bodyTableWrapper = create('div', {class: settings.wrapperClass})
        var bodyTable = create('table', {class: settings.bodyClass})
        var bodyTableHead = create('tbody')
        var bodyTableQuarters = create('tr')
        var first = 'undefined'
        var last
        for (i = 0; i < range; i++) {
            for (var q = 0; q < settings.parts; q++) {
                var extraClasses = ''
                if (storage[year + '' + (q + 1)]) {
                    if (typeof first !== 'undefined') {
                        last = first.next
                    }
                    first = storage[year + '' + (q + 1)]
                    extraClasses = 'first'
                }
                if (typeof last !== 'undefined') {
                    if (String(year + '' + (q + 1)) == String(last.year + '' + last.quarter)) {
                        bodyTableQuarters.lastChild.className += ' last'
                    }
                }
                var img = create('div', {class: 'circle'})
                var td = create('td', {class: settings.itemClass + ' quarter_' + String(q + 1) + ' year_' + year + ' ' + first.class + ' ' + extraClasses})
                td.appendChild(img)
                bodyTableQuarters.appendChild(td)
            }
            year++
        }
        bodyTableQuarters.lastChild.className += ' last'
        bodyTableHead.appendChild(bodyTableQuarters)
        bodyTable.appendChild(bodyTableHead)
        bodyTableWrapper.appendChild(bodyTable)
        return bodyTableWrapper
    }

    this.selectCurrent = function () {
        var today = new Date()
        var year = today.getFullYear()
        var quarter = Math.floor((today.getMonth() + 3) / 3)
        $('.' + settings.wrapperClass).each(function (i, ele) {
            var $ele = $(ele)
            $ele.find('.year_' + year + '.quarter_' + quarter + ':not(current)').addClass('current')
        })
        return true
    }

    var handleHorizontalScroll = function () {
        $('.' + settings.wrapperClass).mousedown(function (event) {
            $('.' + settings.datastore)
                .data('down', true)
                .data('x', event.clientX)
                .data('scrollLeft', this.scrollLeft)
                .addClass("dragging")
            return false
        }).mouseup(function (event) {
            $('.' + settings.datastore)
                .data('down', false)
                .removeClass("dragging")
        }).mousemove(function (event) {
            if ($('.' + settings.datastore).data('down') == true) {
                $('.' + settings.wrapperClass).scrollLeft($('.' + settings.datastore).data('scrollLeft') + $('.' + settings.datastore).data('x') - event.clientX)
            }
        })
        $(document).mouseup(function (event) {
            $('.' + settings.datastore)
                .data('down', false)
                .removeClass("dragging")
        })
        $('.nextArrow').on('click', function () {
            $('.' + settings.wrapperClass).stop().animate({scrollLeft: '+=250'}, 300)
        })

        $('.prevArrow').on('click', function () {
            $('.' + settings.wrapperClass).stop().animate({scrollLeft: '-=250'}, 300)
        })
    }

    this.destroy = function () {
        $('.parentHeaderRow').remove()
        $(settings.itemIdentifier + ' .' + settings.wrapperClass).remove()
    }

    var setupDatastore = function () {
        if ($('body').find('.' + settings.datastore).length === 0) {
            $('body').append(create('div', {class: settings.datastore}))
        }
    }

    var setup = function () {
        var allLoaded = false
        if ($('.' + settings.headerClass).length === 0) {
            $(settings.tableIdentifier + '_wrapper thead').append(createHeader())
            $('.' + settings.headerClass).parent().parent().css({paddingTop: 0, paddingBottom: 0, position: 'relative'})
        } else {
            allLoaded = true
        }
        $(settings.itemIdentifier).each(function (i, bodyElement) {
            if ($(bodyElement).find('.' + settings.bodyClass).length === 0) {
                var $bodyElement = $(bodyElement)
                $bodyElement.parent().css({paddingTop: 0, paddingBottom: 0})
                $(bodyElement).append(createBody($bodyElement), $bodyElement)
            } else {
                allLoaded = true
            }
        })
        if (!allLoaded) {
            $('.' + settings.wrapperClass).scrollLeft(0)
        }

    }

    var measureAndSetWidth = function () { // Standalone only
        var width = $element.closest('.child').width() - 2
        $('.standalone_timelineWrapper').width(width)
    }

    var resize = function () { // Standalone only
        measureAndSetWidth()
        $(window).resize(function () {
            $('.standalone_timelineWrapper').width(0)
            measureAndSetWidth()
        })
    }

    var setupStandalone = function () {
        var standaloneHeaderTable = create('table', {'class': 'timeline-standalone-header'})
        var standaloneHeaderTableHead = create('thead')
        standaloneHeaderTableHead.appendChild(createHeader())
        standaloneHeaderTable.appendChild(standaloneHeaderTableHead)
        $element.before(standaloneHeaderTable)
        $element.append(createBody($element), $element)
    }

    if (settings.standalone) {
        settings.range = 9
        settings.wrapperClass = 'standalone_timelineWrapper'
        settings.tableIdentifier = 'standalone_timelineWrapper'
        settings.headerClass = 'standalone_timelineHeader'
        settings.parentHeaderClass = 'standalone_parentHeaderRow'
        $.when(setupStandalone())
            .then(resize())
            .then(this.selectCurrent())
            .then(setupDatastore())
            .then(handleHorizontalScroll())

    } else {
        if (!jQuery().dataTable) {
            throw 'Datatables not installed'
        }
        var that = this
        $.when(setup())
            .then(this.selectCurrent())
            .then(setupDatastore())
            .then(handleHorizontalScroll())

    }
}

$.fn.timeline = function (options) {
    if ($(this).length > 0) {
        var element = $(this)
    }
    // pass options to plugin constructor
    var timeline = new timelinePlugin(this, options)

    // Store plugin object in this element's data
    if (element) {
        element.data('timeline', timeline)
    }
    return timeline
}

